const howItWorksSteps = {
  en: [
    {
      id: 1,
      title: "Tell us about your problem",
      description:
        "Answer a short questionnaire about your problem, injury history, and goals so we can tailor your program.",
      image: null,
    },
    {
      id: 2,
      title: "Get your personal plan",
      description:
        "We generate a step-by-step video-based therapy plan you can follow from home, at your own pace.",
      image: null,
    },
    {
      id: 3,
      title: "Follow along with videos",
      description:
        "Watch clear exercise videos and written instructions, track your progress, and adjust intensity safely.",
      image: null,
    },
    {
      id: 4,
      title: "Review and refine",
      description:
        "Update your symptoms and we refine your program so you keep improving week after week.",
      image: null,
    },
    {
      id:5,
      title: "Contact for additonal support",
      description: "Behind the app, there is always an expert you can turn to—partner physiotherapists ready to review your progress and help when something doesn’t feel right.",
    },
  ],
  sl: [
    {
      id: 1,
      title: "Povejte nam, kje in kaj je vaš problem, kaj želite izboljšati.",
      description:
        "Odgovorite na vprašalnik o problemu, preteklih poškodbah in ciljih, da lahko prilagodimo program.",
      image: null,
    },
    {
      id: 2,
      title: "Prejmite osebni program",
      description:
        "Pripravimo korak‑za‑korakom video program, ki ga lahko izvajate doma, v tempu, ki vam ustreza.",
      image: null,
    },
    {
      id: 3,
      title: "Sledite vajam v videih",
      description:
        "Glejte jasne video prikaze in pisna navodila, spremljajte napredek in varno zvišujte obremenitev.",
      image: null,
    },
    {
      id: 4,
      title: "Redno prilagajanje",
      description:
        "Posodobite, kako se počutite, mi pa program prilagodimo, da nadaljujete z skrbjo za vaše zdravje.",
      image: null,
    },
    {
      id:5,
      title: "Kontaktirajte nas za dodatno podporo",
      description: "V našo podporo so vedno vključeni strokovnjaki – partnerski fizioterapevti, na katere se lahko obrnete, da pregledajo vaš napredek in pomagajo pri postopku ali spremembah programa.",
    },
  ],
};

export default howItWorksSteps;
